var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrappper"},[_c('div',{staticClass:"row tool-container"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 pr-0 pl-0"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }